import * as actions from './actions';
import { Record, Map } from 'immutable';
export var InitialState = Record({
  defaultLocale: 'en',
  messages: new Map(),
  selectedLocale: 'en'
});
var initialState = new InitialState();
/**
 * Translation Redux reducer
 * @param  {Object} inputState  App state
 * @param  {Object} action      Flux action
 * @return {Object}             Updated app state
 */

export default function translationReducer() {
  var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var state = !(inputState instanceof InitialState) ? initialState.mergeDeep(inputState) : inputState;
  switch (action.type) {
    case actions.TRANSLATE_CHANGE_LOCALE:
      return state.set('selectedLocale', action.value);
    case actions.TRANSLATE_UPDATE_MESSAGES:
      return state.update('messages', function (messages) {
        return messages.mergeDeep(action.value);
      });
  }
  return state;
}